import React from 'react';
import { cn } from './cn';
export default function CodeBlock({ label, value, tone, className, children, ...props }) {
  return <div className="min-w-0 max-w-full">
    {label && <div className="mb-1 text-bun-meta font-strong text-bun-stone">{label}</div>}
    <pre {...props} className={cn('m-0 max-h-80 overflow-auto whitespace-pre-wrap break-words rounded-bun border border-bun-line bg-bun-mist px-3 py-2 font-instrument text-bun-meta leading-relaxed text-bun-slate', tone === 'error' && 'border-bun-danger-border bg-bun-danger-bg text-bun-danger', className)}>{value ?? children}</pre>
  </div>;
}
